(function () {
    'use strict';

    var activeClose = null;

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && activeClose) {
            activeClose();
        }
    });

    function extractYouTubeId(url) {
        var m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/);
        return m ? m[1] : null;
    }

    function initAboutSection(section) {
        var btn       = section.querySelector('.c-about-section__video-btn');
        var modal     = section.querySelector('.c-about-section__modal');
        var backdrop  = section.querySelector('.c-about-section__modal-backdrop');
        var mediaWrap = section.querySelector('.c-about-section__modal-media');
        var closeBtn  = section.querySelector('.c-about-section__modal-close');
        var videoUrl  = section.dataset.video || '';

        if (!btn || !modal || !videoUrl) return;

        function openModal() {
            var ytId = extractYouTubeId(videoUrl);
            mediaWrap.innerHTML = '';
            if (ytId) {
                var iframe = document.createElement('iframe');
                iframe.src = 'https://www.youtube-nocookie.com/embed/' + ytId + '?autoplay=1&rel=0';
                iframe.setAttribute('frameborder', '0');
                iframe.setAttribute('allow', 'autoplay; encrypted-media; fullscreen; picture-in-picture');
                iframe.setAttribute('allowfullscreen', '');
                mediaWrap.appendChild(iframe);
            } else {
                var video = document.createElement('video');
                video.src = videoUrl;
                video.controls = true;
                video.autoplay = true;
                video.playsInline = true;
                mediaWrap.appendChild(video);
            }
            modal.removeAttribute('hidden');
            document.body.style.overflow = 'hidden';
            activeClose = closeModal;
            closeBtn.focus();
        }

        function closeModal() {
            mediaWrap.innerHTML = '';
            modal.setAttribute('hidden', '');
            document.body.style.overflow = '';
            activeClose = null;
            btn.focus();
        }

        btn.addEventListener('click', openModal);
        closeBtn.addEventListener('click', closeModal);
        backdrop.addEventListener('click', closeModal);
    }

    document.querySelectorAll('.c-about-section').forEach(initAboutSection);
})();
